// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_14207a1"};